import { UsageSteps } from 'app/src/features/UserJoin/components/ConfirmStep/UsageSteps'
import { CheckCatalogButton, Image } from 'app/src/shared/components'
import { useWelfarePortalNavigate } from 'app/src/shared/hooks'
import successImage from 'app/static/images/success_img.png'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function JoinSuccess() {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Success' })
  const { t: tCancelFunnel } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Confirm.cancelJoinSection.unjoinSuccess' })
  const navigate = useWelfarePortalNavigate()

  return (
    <>
      <div className='mt-2 flex'>
        <div className='mx-auto'>
          <div className='mx-auto my-4 text-center text-[28px] font-bold' dangerouslySetInnerHTML={{ __html: t('trailer') }} />
          <Image
            pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
            src={successImage}
            alt='Immagine di successo'
          />
          <div className='mx-auto my-4 text-center text-[18px]' dangerouslySetInnerHTML={{ __html: t('footer') }} />
          <div>
            <UsageSteps></UsageSteps>
          </div>
        </div>
      </div>
      <div className='sticky bottom-0 left-0 right-0 bg-white py-4 shadow-md'>
        <div className='mx-auto flex justify-center'>
          <CheckCatalogButton />
        </div>
        <div className='mx-auto flex justify-center'>
          <Button link label={tCancelFunnel('goToLandingBtnLabel')} onClick={navigate.goToLanding}></Button>
        </div>
      </div>
    </>
  )
}
